<template>
  <div>
    <DetailIndex :tcExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-tc-expense',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
